import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CreditFlow } from '../../../../core/enum/mysec/credit-flow.enum';
import { WalletTransactionEvent } from '../../../../core/enum/mysec/wallet-transaction-event.enum';
import { TransactionList } from '../../../../core/models/mysec/transaction-list';
import { ToastService } from '../../../../core/services/toast.service';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    standalone: false
})
export class OrderSummaryComponent implements OnInit {
  isLoading: boolean = true;

  // Always set by the opener (wallet.component showOrderSummary). Empty default so a
  // missed assignment renders the graceful empty state rather than stale placeholder data.
  transaction: TransactionList = {} as TransactionList;

  CreditFlow: typeof CreditFlow = CreditFlow;
  WalletTransactionEvent: typeof WalletTransactionEvent = WalletTransactionEvent;

  constructor(
    public modal: NgbActiveModal,
    private readonly clipboard: Clipboard,
    private readonly toastService: ToastService,
    private readonly translateService: TranslateService,
  ) {}

  /**
   * Whether this transaction is a PSTX Buy (true) or Sell (false), derived from
   * the wallet transaction event. Returns null when the event is neither
   * BuyShares nor SellShares (e.g. TopUp/Withdraw) so the badge is hidden.
   */
  get isBuy(): boolean | null {
    const event = this.transaction?.walletTransactionHistory?.event;
    if (event === WalletTransactionEvent.BuyShares) {
      return true;
    }
    if (event === WalletTransactionEvent.SellShares) {
      return false;
    }
    return null;
  }

  /**
   * Shares Value subtotal = sum of the per-fill order-detail amounts (the
   * matched-order value before the trading fee). Distinct from tradingFee and
   * totalAmount.
   */
  get sharesValue(): number {
    const details = this.transaction?.orderSummary?.orderDetail;
    if (!details?.length) {
      return 0;
    }
    return details.reduce((sum, detail) => sum + (detail?.amount ?? 0), 0);
  }

  ngOnInit() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  /** Copy the transaction's reference number to the clipboard (Figma: "Transaction ID" pill). */
  copyTransactionId(): void {
    const reference = this.transaction?.walletTransactionHistory?.referenceNumber;
    if (!reference) {
      return;
    }
    this.clipboard.copy(reference);
    this.toastService.success(this.translateService.instant('common.copiedToClipboard'));
  }

  close() {
    this.modal.dismiss();
  }
}
